import { all } from 'redux-saga/effects'
import { watchYieldUser } from './user'
import { watchYieldHome } from './home'
import { watchYieldBind } from './bind'
import { watchYieldAuth } from './auth'
export default function* rootSaga() {
  yield all([
    watchYieldUser(),
    watchYieldHome(),
    watchYieldBind(),
    watchYieldAuth()
  ])
}



// WEBPACK FOOTER //
// ./src/saga/index.tsx